module.exports = __webpack_public_path__ + "static/media/back-pc.9d91c39d.jpg";